
import { Component, Vue } from 'vue-property-decorator';
import CircleChart from './comonents/circleChart.vue';
import BarChart from './comonents/barChart.vue';
import NavigationCircle from './comonents/navigationCirle.vue';
import moment from "moment";
import { UserModule } from "@/store/modules/user";
import {
    SickLeaveVisitSettingService, DailyAttendanceInspectionByPosition,DailyAttendanceInspectionReportItem,PositionDetail
} from "@/api/service-proxies";

moment.locale('zh-cn'); // 设置为中文
@Component({
  components: {
    CircleChart,
    BarChart,
    NavigationCircle
  }
})
export default class StudentAttendance extends Vue {
  private chartData: any[] = [
    ["06月27日", "113", "1008", "0"],
    ["06月28日", "0", "1121", "0"],
    ["06月29日", "0", "1121", "0"],
    ["06月30日", "113", "1008", "0"],
    ["07月01日", "113", "1008", "0"]
  ];
  sickLeaveVisitSetting = new SickLeaveVisitSettingService();
  resultData = new DailyAttendanceInspectionByPosition({
    staticItem : new PositionDetail(),
    positionDetails : []
  })
  updateTimeSecond=300000;//默认5分钟一次
  isFullscreen = false;
  nowDay = moment().format('YYYY年MM月DD日')
  weekDay= moment().format('dddd'); // 例如："星期三"
  currentTime = this.getCurrentTime()
 leaveNumber=0
  private fullscreenElement: HTMLElement | null = null;
  timer
  mounted() {
    this.getRepotItemByPosition();
     // 当组件挂载到 DOM 上时，开始更新时间
     this.timer = setInterval(this.updateTime, 1000);
     this.requstTime();
     this.fullscreenElement = this.$refs.screenContainer as HTMLElement;
  }
  requstTime() {
        setInterval(() => {
            this.getRepotItemByPosition();
        }, this.updateTimeSecond);//十分钟一次自动刷新，
    }
  updateTime() {
        this.currentTime = this.getCurrentTime();
    }
  private async logout() {
    await UserModule.LogOut();
    location.reload();
  }


  //获取数据
   getRepotItemByPosition(){
    this.sickLeaveVisitSetting.getDailyAttendanceInspectionByPosition()
    .then((res)=>{
       this.resultData = res;
       this.leaveNumber=res.staticItem.leaveCompassionateNum+res.staticItem.sickLeaveNum
    })
    .catch(e=>{

    })
   }

  getCurrentTime() {
    const now = new Date();
    const hours = String(now.getHours()).padStart(2, '0');
    const minutes = String(now.getMinutes()).padStart(2, '0');
    const seconds = String(now.getSeconds()).padStart(2, '0');
    return `${hours}:${minutes}:${seconds}`;
  }
  handleDoubleClick(){
    this.$router.push({name:'analysisNew'})
  }
    // 初始化全屏（必须由用户点击直接触发）
    initFullscreen() {
    if (!this.fullscreenElement) return;

    try {
      const elem = this.fullscreenElement;
      const requestFn = elem.requestFullscreen ||
        elem.webkitRequestFullscreen ||
        elem.msRequestFullscreen;

      if (requestFn) {
        requestFn.call(elem);
      }
    } catch (err) {
      console.error('全屏失败:', err);
      this.$message.error('全屏模式不可用');
    }
  }
   // 设置全屏状态监听
   setupFullscreenListeners() {
    document.addEventListener('fullscreenchange', this.handleFullscreenChange);
    document.addEventListener('webkitfullscreenchange', this.handleFullscreenChange);
  }

  cleanupFullscreenListeners() {
    document.removeEventListener('fullscreenchange', this.handleFullscreenChange);
    document.removeEventListener('webkitfullscreenchange', this.handleFullscreenChange);
  }

  handleFullscreenChange() {
    this.isFullscreen = !!(
      document.fullscreenElement ||
      document.webkitFullscreenElement
    );
  }
}
